import { render } from "./VideoPlayerModal.vue?vue&type=template&id=12f33060&scoped=true&ts=true&lang=pug"
import script from "./VideoPlayerModal.vue?vue&type=script&lang=ts"
export * from "./VideoPlayerModal.vue?vue&type=script&lang=ts"

import "./VideoPlayerModal.vue?vue&type=style&index=0&id=12f33060&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f33060"]])

export default __exports__